var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceshipBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 290.06 468.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ddd;}.cls-2,.cls-3{opacity:.8;}.cls-2,.cls-3,.cls-4{stroke:#afafaf;}.cls-2,.cls-3,.cls-4,.cls-5{fill:none;stroke-miterlimit:10;}.cls-6{fill:#727272;}.cls-7{fill:#a0a0a0;}.cls-8{isolation:isolate;}.cls-9{fill:#232323;}.cls-10{fill:#e0e0e0;}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_75);opacity:.3;}.cls-11,.cls-12,.cls-13{mix-blend-mode:multiply;}.cls-14{fill:#969696;}.cls-15{fill:#3a3a3a;}.cls-16{fill:#ff931e;}.cls-12{opacity:.5;}.cls-17{fill:#afafaf;}.cls-18{fill:#e8e8e8;}.cls-19{fill:#d7f1ff;mix-blend-mode:screen;opacity:.2;}.cls-20{fill:#4b9cff;opacity:.7;}.cls-20,.cls-21{mix-blend-mode:overlay;}.cls-22,.cls-13{fill:#5c7784;}.cls-3{stroke-width:1.49px;}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_31);}.cls-13{opacity:.4;}.cls-4{stroke-width:1.1px;}.cls-5{stroke:#a0a0a0;stroke-width:.93px;}.cls-23{fill:#5e5e5e;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "spaceship_3",
    viewBox: "0 0 145.44 466.86"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "61.94 460.78 1.35 460.78 1.35 415.86 59.35 415.86 59.66 421.78 60.23 432.49 61.94 460.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M59.34,445.38l3,15.96c0,3.05-2.43,5.52-5.43,5.52H1.34v-27H53.92c3,0,5.43,2.47,5.43,5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M56.52,452.11l.9,4.24c0,3.05-2.43,5.52-5.43,5.52H1.34v-15.09H49c3,0,7.52,2.28,7.52,5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M52.52,453.11l1,2.95c0,1.68-2.26,3.05-5.05,3.05H1.34v-8.33H45.68c2.79,0,6.84,.65,6.84,2.33Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "60.23 432.49 35.94 456.86 16.18 456.86 9.33 450.56 1.35 450.56 1.35 422.44 9.78 421.86 59.66 421.78 60.23 432.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "70.66 140.78 0 140.78 0 25.78 47.84 25.78 47.9 26.33 47.92 26.46 64.66 113.13 70.66 140.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "48.74 269.52 38.42 269.52 33.38 269.52 1.03 269.52 1.03 140.32 70.43 140.32 70.77 141.59 78.42 192.57 78.83 194.1 84.92 228.8 85.33 230.34 85.83 269.52 48.74 269.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M145.34,318v48.69c0,.68-.23,1.34-.66,1.86l-8.61,10.56c-.46,.56-1.15,.89-1.88,.89h-9.47c-.76,0-1.38-.62-1.38-1.38v-12.3H1.34v-56.2l32.09-.39,5-.06,10.25-.12,36.66-.44h.11l50.65-.09c.79,0,1.55,.32,2.07,.91l7.17,8.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1.35,
    y: 268,
    width: 84.61,
    height: 81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "86.35 349 85.85 351.07 85.62 352.04 80.59 372.85 80.37 373.79 75.65 393.32 75.43 394.25 54.35 436 1.35 436 1.35 349 86.35 349"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "54.34 436 54.16 436.18 35.34 455 17.34 455 9.59 449.18 1.34 449 1.34 436 54.34 436"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "48.02 26 .08 26 .08 3 26.57 3 47.39 25.32 47.9 25.87 48.02 26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "26.51 3 .08 3 .08 0 21.48 0 26.51 3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M42.68,32.5H.08V10.5H20.93c.3,0,.6,.03,.89,.1,.75,.15,1.41,.52,1.89,1.03l12.45,13.69,.61,.68,5.91,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.68,31.5H.08V12.5H18.5c.96,0,1.87,.37,2.45,.98l11,11.84,.62,.68,5.11,5.5Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1.34 416 29.31 416 33.43 416 37.93 416 38.43 415.4 47.93 404 48.14 349 48.15 348.57 48.27 315.58 48.46 268.32 48.46 268 48.67 213.25 48.68 211.55 48.93 141.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 22.52,
    y1: 0.5,
    x2: 22.52,
    y2: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1.35,
    y: 302.72,
    width: 20.04,
    height: 42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 27,
    y1: 3.5,
    x2: 24.35,
    y2: 11.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 47.08,
    y1: 25.82,
    x2: 42.82,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.43,
    y1: 417.37,
    x2: 54.43,
    y2: 436.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.39,313.56c9.38,.44,18.36,1.14,26.89,2.02,9.4,.98,18.28,2.18,26.57,3.5,.17,.03,10.74,2.51,10.91,2.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M38.44,303.67v2c-5.52-.46-11.2-.84-17.05-1.11-6.49-.32-13.18-.5-20.04-.54v-2c11.2,.06,21.9,.51,32.09,1.26,1.68,.12,3.35,.25,5,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M38.43,345.67v73c-1.41-.12-2.84-.23-4.27-.34-.24,0-.48-.03-.73-.05v-73c1.68,.12,3.35,.25,5,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M33.43,416.28v2c-10.18-.74-20.89-1.2-32.09-1.26v-2c9.7,.05,19.03,.4,27.97,.98,1.38,.09,2.76,.18,4.12,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M38.44,345.67v2c-1.65-.14-3.32-.27-5-.39-.01,0-.02-.01-.03,0-1.35-.1-2.72-.2-4.09-.28-1.38-.09-2.78-.18-4.18-.25-1.48-.09-2.96-.16-4.46-.23-1.34-.06-2.7-.12-4.05-.17-4.32-.16-8.72-.27-13.19-.32-.49-.01-.98-.01-1.48-.01h-.61v-2c6.87,.04,13.55,.22,20.04,.53,4.1,.19,8.11,.44,12.05,.73,1.68,.12,3.35,.25,5,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M33.43,112.28v2c-10.18-.74-20.89-1.2-32.09-1.26v-2c11.2,.06,21.91,.51,32.09,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.34,110.01c17.09,.11,48.29,2.47,63.29,6.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.34,138.01c11.2,.07,21.91,.53,32.09,1.27,1.68,.12,3.35,.25,5,.39,2.43,.2,4.83,.41,7.2,.65,2.33,.23,22.73,1.91,25,2.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.35,346.01c.2,0,.41,0,.61,.01,.5,0,.99,0,1.48,0,4.48,.04,8.88,.15,13.19,.32,1.36,.05,2.71,.11,4.05,.17,1.5,.07,2.98,.14,4.46,.23,1.4,.07,2.8,.16,4.18,.25,1.37,.08,2.74,.18,4.09,.28,.01,0,.02,0,.03,0,1.68,.12,3.35,.25,5,.39,3.3,.27,6.54,.57,9.72,.9,1.35,.14,2.68,.28,4.01,.43,7.88,.88,25.52,4.51,32.59,5.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M33.43,112.28v191c-10.18-.75-20.89-1.2-32.09-1.26V111.02c11.2,.06,21.91,.51,32.09,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M33.43,44.5v55c-11-1-19.93-1.99-32-2h-.09V44.5H33.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M38.43,112.67v192.83l-5-2V112.28c1.14,.08,2.28,.17,3.4,.26,.54,.04,1.07,.09,1.6,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M33.44,345.28v73c-10.19-.74-20.89-1.2-32.09-1.26v-73c6.87,.04,13.55,.22,20.04,.53,4.1,.19,8.11,.44,12.05,.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "38.89 445.5 1.34 445.5 1.34 422.5 31.4 422.5 35.8 436 38.89 445.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "37.02 445.18 1.34 445.18 1.34 423.5 29.73 423.5 30.07 424.5 31.08 427.5 31.41 428.5 32.08 430.5 32.42 431.5 33.43 434.5 33.77 435.5 34.11 436.5 34.43 437.5 34.77 438.5 35.11 439.5 36.12 442.5 36.46 443.5 37.02 445.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.34,
    y: 32.5,
    width: 36.09,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1.34,
    y: 445.5,
    width: 37.55,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M145.44,329.34v15h-4.5c-4.01,0-7.29-3.15-7.48-7.11-.02-.13-.02-.26-.02-.39,0-2.07,.84-3.94,2.2-5.3,1.36-1.36,3.23-2.2,5.3-2.2h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140.94,329.34h4.5v1.72h-5.36c-3.51,0-6.38,2.72-6.62,6.17-.02-.13-.02-.26-.02-.39,0-2.07,.84-3.94,2.2-5.3,1.36-1.36,3.23-2.2,5.3-2.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 145.44,
    y1: 318.34,
    x2: 85.26,
    y2: 318.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 145.44,
    y1: 358.84,
    x2: 85.26,
    y2: 358.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "35.44 99.84 33.44 99.84 33.44 44.84 35.44 45.84 35.44 99.84"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_31",
    x1: 51.27,
    y1: 160.06,
    x2: 253.95,
    y2: 358.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfbfbf",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#929292",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#4e4e4e",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#262626",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_75",
    x1: 109.33,
    y1: 302.69,
    x2: 276.13,
    y2: 421.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f2f5f6",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e6ebed",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#abb9c0",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7f959f",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#657f8b",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c7784"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("use", {
    width: 145.44,
    height: 466.86,
    transform: "translate(144.02)",
    xlinkHref: "#spaceship_3"
  }), /*#__PURE__*/React.createElement("use", {
    width: 145.44,
    height: 466.86,
    transform: "translate(145.44) rotate(-180) scale(1 -1)",
    xlinkHref: "#spaceship_3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M200.96,80.43c-11.17,35.74-27.35,72.85-48.48,109.45-33.66,58.3-74.73,106.39-116.77,140.21H0v-.76H.09v-11.33l7.18-8.07c.52-.59,1.28-.93,2.07-.92l50.14,.1v-41.11h.15l.47-37.67,.42-1.53,6.09-34.7,.41-1.53,7.64-50.98,.22-.82h-.1l6-27.65L97.52,26.45l.02-.13,.03-.32h-.16l.13-.13,.05-.06v-.04h.03l.42-.45L118.86,3h.07l5.03-3h40.13l5.03,3h.07l10.04,10.77,10.78,11.55,.42,.45h.03v.04l.05,.06,.13,.13h-.16l.04,.32,.02,.13,10.42,53.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M289.96,331.33v-11.34l-7.17-8.07c-.53-.59-1.28-.92-2.07-.91l-50.15,.09v-41.11h-.15l-.47-37.66-.41-1.53-6.09-34.7-.41-1.53-7.64-50.98-.22-.81h.1l-6-27.65-16.74-86.67-.02-.13-.04-.33h.16l-.13-.13-.05-.06v-.03h-.03l-.42-.46-20.82-22.32h-.07l-5.03-3h-40.13l-5.03,3h-.07l-20.82,22.32-.42,.46h-.03v.03s-.06,.06-.06,.06l-.13,.13h.16l-.04,.33-.02,.13-16.74,86.67-6,27.65h.1l-.22,.81-7.64,50.98-.41,1.53-6.09,34.7-.41,1.53-.48,37.66h-.15v41.11l-50.15-.09c-.79,0-1.55,.32-2.07,.91l-7.17,8.07v11.34h-.09v15h.09v22.35c0,.68,.23,1.34,.66,1.86l8.61,10.56c.46,.56,1.15,.89,1.88,.89h9.47c.76,0,1.38-.62,1.38-1.38v-12.3h41.18l1.58,6.53,.22,.94,4.72,19.53,.22,.93,15.59,30.88-.39,7.36-1.57,25.93-.55,2.93c0,3.05,2.43,5.52,5.43,5.52h111.02c3,0,5.43-2.47,5.43-5.52l-.55-2.93-1.57-25.93-.39-7.36,15.59-30.88,.22-.93,4.72-19.53,.22-.94,1.58-6.53h41.18v12.3c0,.76,.62,1.38,1.38,1.38h9.47c.73,0,1.42-.33,1.88-.89l8.61-10.56c.43-.53,.66-1.18,.66-1.86v-22.35h.09v-15h-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M290.06,331.33v15h-.1v22.36c0,.68-.23,1.33-.66,1.86l-8.61,10.56c-.46,.56-1.15,.89-1.88,.89h-9.47c-.76,0-1.38-.62-1.38-1.38v-12.3h-41.18l-1.57,6.53-.22,.94-4.72,19.53-.22,.93-15.6,30.88,.39,7.36,1.57,25.93,.55,2.92c0,3.05-2.43,5.52-5.43,5.52H90.52c-3,0-5.43-2.47-5.43-5.52l.55-2.92,1.57-25.93v-.28c50.73-32.76,98.3-98.86,125.19-182.33,5.14-15.96,9.3-31.84,12.5-47.49l4.64,26.41,.41,1.53,.47,37.67h.15v41.11l50.15-.1c.79-.01,1.54,.33,2.07,.92l7.17,8.07v11.33h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M289.96,329.33v-11.34l-7.17-8.07c-.53-.59-1.28-.92-2.07-.91l-50.15,.09v-41.11h-.15l-.47-37.66-.41-1.53-6.09-34.7-.41-1.53-7.64-50.98-.22-.81h.1l-6-27.65-16.74-86.67-.02-.13-.04-.33h.16l-.13-.13-.05-.06v-.03h-.03l-.42-.46L171.19,3h-.07l-5.03-3h-40.13l-5.03,3h-.07l-20.82,22.32-.42,.46h-.03v.03s-.06,.06-.06,.06l-.13,.13h.16l-.04,.33-.02,.13-16.74,86.67-6,27.65h.1l-.22,.81-7.64,50.98-.41,1.53-6.09,34.7-.41,1.53-.48,37.66h-.15v41.11l-50.15-.09c-.79,0-1.55,.32-2.07,.91l-7.17,8.07v11.34h-.09v15h.09v22.35c0,.68,.23,1.34,.66,1.86l8.61,10.56c.46,.56,1.15,.89,1.88,.89h9.47c.76,0,1.38-.62,1.38-1.38v-12.3h41.18l1.58,6.53,.22,.94,4.72,19.53,.22,.93,15.59,30.88-.39,7.36-1.57,25.93-.55,2.93c0,3.05,2.43,5.52,5.43,5.52h111.02c3,0,5.43-2.47,5.43-5.52l-.55-2.93-1.57-25.93-.39-7.36,15.59-30.88,.22-.93,4.72-19.53,.22-.94,1.58-6.53h41.18v12.3c0,.76,.62,1.38,1.38,1.38h9.47c.73,0,1.42-.33,1.88-.89l8.61-10.56c.43-.53,.66-1.18,.66-1.86v-22.35h.09v-15h-.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M143.53,27.28v4.22h-37.6l3.55-3.82c8.58,1.38,18.96,1.53,30,.17,1.37-.17,2.72-.36,4.05-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M181.33,31.5h-37.6v-4.25c10.17-1.6,19.32-4.31,26.57-7.64l5.3,5.71,.62,.68,5.11,5.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M125.11,12.5h18.42v5.5c-8.18,0-15.86-1-22.51-2.76l1.64-1.76c.58-.61,1.49-.98,2.45-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M166.2,15.2c-6.63,1.77-14.3,2.78-22.47,2.8v-5.5h18.42c.96,0,1.87,.37,2.45,.98l1.6,1.72Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceshipBlue);
export default __webpack_public_path__ + "static/media/spaceshipBlue.af6659f34bc87253dd867f0e7c4cdbf4.svg";
export { ForwardRef as ReactComponent };